import { LocalTime } from '@js-joda/core'

export const REAL_TIME_STT_SEGMENT_INTERVAL_MINUTES = 15
export const REAL_TIME_STT_SEGMENT_INTERVAL_MILLIS =
  REAL_TIME_STT_SEGMENT_INTERVAL_MINUTES * LocalTime.SECONDS_PER_MINUTE * 1000
